import React, { useState, useEffect } from 'react';
import { getClasses, addClass, deleteClass } from '../../api';
import { toast } from 'react-toastify';

const ManageClasses = () => {
  const [classes, setClasses] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: '', section: '', group_name: ''
  });

  useEffect(() => { loadClasses(); }, []);

  const loadClasses = async () => {
    try {
      const res = await getClasses();
      setClasses(res.data);
    } catch (err) {
      toast.error('Error loading classes');
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addClass(formData);
      toast.success('Class added!');
      setShowForm(false);
      setFormData({ name: '', section: '', group_name: '' });
      loadClasses();
    } catch (err) {
      toast.error('Error adding class');
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this class?')) {
      try {
        await deleteClass(id);
        toast.success('Class deleted!');
        loadClasses();
      } catch (err) {
        toast.error('Error');
      }
    }
  };

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>Manage Classes</h3>
        <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
          + Add Class
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>Add New Class</h4>
          <form onSubmit={handleAdd}>
            <div style={styles.formGrid}>
              <div>
                <label style={styles.label}>Class Name</label>
                <select style={styles.input} value={formData.name}
                  onChange={e => setFormData({...formData, name: e.target.value})} required>
                  <option value="">Select Class</option>
                  <option value="9th">9th</option>
                  <option value="10th">10th</option>
                  <option value="1st Year">1st Year</option>
                  <option value="2nd Year">2nd Year</option>
                </select>
              </div>
              <div>
                <label style={styles.label}>Section</label>
                <input style={styles.input} placeholder="e.g. A, B, C"
                  value={formData.section}
                  onChange={e => setFormData({...formData, section: e.target.value})} />
              </div>
              <div>
                <label style={styles.label}>Group</label>
                <select style={styles.input} value={formData.group_name}
                  onChange={e => setFormData({...formData, group_name: e.target.value})}>
                  <option value="">Select Group</option>
                  <option value="Science">Science</option>
                  <option value="Computer">Computer</option>
                  <option value="Pre-Medical">Pre-Medical</option>
                  <option value="Pre-Engineering">Pre-Engineering</option>
                  <option value="ICS">ICS</option>
                  <option value="FA IT">FA IT</option>
                  <option value="FA Arts">FA Arts</option>
                </select>
              </div>
            </div>
            <div style={styles.btnGroup}>
              <button type="submit" style={styles.addBtn}>Save</button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={styles.grid}>
        {classes.map(c => (
          <div key={c.id} style={styles.classCard}>
            <div style={styles.classIcon}>🏫</div>
            <h4 style={styles.className}>{c.name}</h4>
            <p style={styles.classInfo}>Section: {c.section || '-'}</p>
            <p style={styles.classInfo}>Group: {c.group_name || '-'}</p>
            <button style={styles.deleteBtn}
              onClick={() => handleDelete(c.id)}>Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a3a5c', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a3a5c', margin: '0 0 15px' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px', marginBottom: '15px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', marginTop: '5px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555' },
  btnGroup: { display: 'flex', gap: '10px' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '15px' },
  classCard: { background: 'white', borderRadius: '12px', padding: '20px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  classIcon: { fontSize: '40px', marginBottom: '10px' },
  className: { color: '#1a3a5c', margin: '0 0 8px', fontSize: '16px' },
  classInfo: { color: '#666', fontSize: '13px', margin: '4px 0' },
  deleteBtn: { marginTop: '10px', padding: '6px 15px', background: '#dc3545', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px' },
};

export default ManageClasses;